import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  container: {
    maxWidth: 1920,
    margin: "auto",
    padding: "0 16px",
  },

  body: {
    display: "grid",
    gap: 48,
    fontFamily: "Philosopher",
    fontWeight: 900,

    maxWidth: 1440,
    padding: "24px 0",
    margin: "auto",
    overflowX: "scroll",
    justifyContent: "space-around",
    color: "white",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",

    [theme.breakpoints.down("sm")]: {
      gap: 16,
      gridTemplateColumns: "1fr 1fr",
    },
  },

  item: {
    backgroundColor: "#2a2828aa",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "24px 0",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "20px",
    minWidth: 136,
    border: "1px solid #0a0a0b",

    "&>div:nth-of-type(1)": {
      display: "flex",
      gap: "8px",
      alignItems: "center",
    },
  },

  coming: {
    color: "#ffffff55",
    fontSize: 16,
  },

  rank: {
    fontSize: 28,
  },

  members: {
    fontSize: 28,
  },

  memberGoldenText: {
    background: theme.palette.text.goldenGradient,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 700,
  },

  memberText: {
    fontSize: 20,
    color: theme.palette.text.secondary,
  },

  premiumMembers: {
    fontSize: 14,
  },

  familyAllegiance: {
    display: "flex",
    gap: 4,
    fontSize: 14,
    "& img": {
      width: 24,
      height: 24,
      borderRadius: 4,
    },
  },
}));

export default styles;
